import adminMeta from '@/router/admin/adminMeta.js'
import securityMeta from '@/router/security/securityMeta.js'

export default [
  {
    path: '/admin/profile/info/:id',
    name: 'admin-profile-info',
    meta: adminMeta,
    component: () => import('@/views/Admin/Profile/AdminProfileInfoView.vue'),
  },
  {
    path: '/admin/profile/documents/:id',
    name: 'admin-profile-documents',
    meta: adminMeta,
    component: () => import('@/views/Admin/Profile/AdminProfileDocumentsView.vue'),
  },
  {
    path: '/admin/profile/changelog/:id',
    name: 'admin-profile-changelog',
    meta: adminMeta,
    component: () => import('@/views/Admin/Profile/AdminProfileChangelogView.vue'),
  },
  {
    path: '/admin/profile/edit/:id',
    name: 'admin-profile-edit',
    meta: adminMeta,
    component: () => import('@/views/Admin/Profile/AdminProfileEditView.vue'),
  },
  {
    path: '/admin/profile/history/:id',
    name: 'admin-profile-history',
    meta: adminMeta,
    component: () => import('@/views/Admin/Profile/AdminProfileHistoryView.vue'),
  },
]
